var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level is-mobile mt-6 px-5 text-color"},[_c('the-logo'),_c('dark-mode')],1)}
var staticRenderFns = []

export { render, staticRenderFns }